/** The because sign (∵): two causes, one consequence. Shared geometry at every size. */
export function BrandSymbol({ className = "" }: { className?: string }) {
  return <svg className={`because-symbol ${className}`} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <path className="symbol-link" d="M12 13 24 35 36 13" pathLength="1" />
    <circle className="symbol-node node-one" cx="12" cy="13" r="7" />
    <circle className="symbol-node node-two" cx="36" cy="13" r="7" />
    <circle className="symbol-node node-three" cx="24" cy="35" r="7" />
  </svg>;
}

export function BrandMark({ compact = false }: { compact?: boolean }) {
  return <span className={compact ? "brand-mark is-compact" : "brand-mark"} aria-hidden="true">
    <BrandSymbol />
    {!compact && <span className="brand-word">Because<span className="brand-period">.</span><span className="brand-fm">FM</span></span>}
  </span>;
}
